<template>
	<div id="demo-form">
		<div v-show="loader" style="margin-top: -10px">
			<Loader />
		</div>
		<div class="datepickerwrap mx-2 " v-if="!couponCodeEnterPopup">
			<div class="card mt-5">
				<ul class="d-inline-flex align-items-center tabs my-3 pl-0 border-bottom" style="gap: 24px">
					<li v-for="section of filteredSections" :key="section" class="cursor-pointer font-lg font-weight-bold px-2"
						:class="selectedSection === section ? 'activeSectionText' : 'deactiveTextColor'
							" @click="setPageSelection(section)">
						{{ section }}
					</li>
				</ul>
				<div class="mx-2 mt-3">
					<div class="stepper-section">
						Step {{ sections.indexOf(selectedSection) + 1 }} of {{ sections.length }}
					</div>
					<component :is="componentMapper[selectedSection]" />
				</div>
			</div>
		</div>
		<div v-if="couponCodeEnterPopup" style="overflow-y: hidden;" class="couponCodeEnterPopupClass"
			:hide-header-close="true" no-close-on-backdrop no-close-on-esc>
			<h3 class="mb-5 mt-0" style="font-size: 20px; color:#050A13">Do you have a trial coupon code?</h3>
			<div class="modal-delete-content d-flex align-items-start mb-2">
				<div class="inputFieldCouponContainer position-relative input-with-icon w-100">
					<div class="position-absolute inputIconContainer">
						<img src="Icons_SVG/couponGiftIcon.svg" height="100%" alt="gift icon" />
					</div>
					<input type="text" name="coupon-code" id="coupon-code" placeholder="Enter coupon code"
						v-model="storeCouponCodeValue" />
				</div>
			</div>
			<div class="d-flex justify-content-end mt-4">
				<b-button class="btn primarycolor align-items-center d-flex justify-content-center" @click="verifyCouponCodeFromApi" :disabled="!storeCouponCodeValue">
					<span style="width: 16.5px; height: 16.5px; display: inline-block" v-if="!verifyCouponCodeLoader">
						<img src="Icons_SVG/CheckCode.svg" height="100%" alt="check icon" />
					</span>
					<span v-if="verifyCouponCodeLoader">
						<b-spinner small class="mt-0" style="margin-bottom: 3px;"></b-spinner>
					</span>
					<span class="ml-2">Redeem
						Coupon</span>
				</b-button>
			</div>
		</div>
		<b-modal v-model="congratulationsPopup" centered hide-header hide-footer>
			<!-- Modal Content -->
			<div class="crossModalPopupCustom cursor-pointer" @click="congratulationsPopup = false">X</div>
			<div class="text-center bgCouponImgContainer pt-5">
				<div style="width:40px; height:40px" class="d-flex justify-content-center align-items-center mx-auto">
					<img src="Icons_SVG/heroIconGift.svg" width="100%" />
				</div>
				<h2 class="mt-4" style="font-size:24px; color:#000000; font-weight: 500;">Congratulations</h2>
				<h3 class="mb-4 mt-3" style="font-size: 20px; color:#050A13; font-weight: 500;">Your Free Trial is
					Activated!</h3>
				<p class="mb-0 text-left" style="color: #050a13; font-size: 16px; font-weight: 400">
					Explore a suite of powerful features, gain valuable insights, and drive your brand’s growth like
					never before.
				</p>
				<p class="mb-2 text-left" style="color: #050a13; font-size: 16px; font-weight: 400">Inclusions:</p>
				<div class="d-flex justify-content-between align-items-center">
					<div style="text-align: start;">
						<p class="mb-0" style="color:#050A13; font-weight: 400; font-size: 16px;">Region: <span
								style="font-weight: 600;">{{ storeCongratulationsPopupDetails && storeCongratulationsPopupDetails.regionName }}</span></p>
						<p class="mb-0" style="color:#050A13; font-weight: 400; font-size: 16px;">Products:
							<span style="font-weight: 600;">{{ storeCongratulationsPopupDetails && storeCongratulationsPopupDetails.products }}</span>
						</p>
					</div>
					<div>
						<p class="mb-0" style="color:#050A13; font-weight: 400; font-size: 16px;">Categories:
							<span style="font-weight: 600;">{{ storeCongratulationsPopupDetails && storeCongratulationsPopupDetails.categorys }}</span>
						</p>
						<p class="mb-0" style="color:#050A13; font-weight: 400; font-size: 16px;">Search Term:
							<span style="font-weight: 600;">{{ storeCongratulationsPopupDetails && storeCongratulationsPopupDetails.search_terms }}</span>
						</p>
					</div>
				</div>
				<div class="couponCodeCopyContainer d-flex justify-content-center align-items-center py-3">
					<div style="border: 2px dashed #A1A1A1; padding: 10px 20px;" @click="clickToCopyCouponCode"
						class="cursor-pointer">
						<p class="mb-0" style="font-size: 20px; color:#A1A1A1">Your Coupon Code</p>
						<p class="mb-0" style="font-weight: 600; color:#000000; font-size: 26px">{{ storeCouponCodeValue
						}}</p>
					</div>
				</div>
				<p class="mb-2 mt-1 text-left" style="color: #050a13; font-size: 16px; font-weight: 400">
					Need any help? We're here for you!<br />
					Reach out at <a href="mailto:support@weavr.online"
						style="color:#065559; font-weight:600">support@weavr.online</a>.
				</p>
			</div>

			<!-- Footer with Close Button -->
			<!-- <template #modal-footer>
        <b-button variant="primary" @click="showModal = false">Close</b-button>
      </template> -->
		</b-modal>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FeaturesPage from "./Sections/FeaturesPage.vue";
import PlatformsPage from "./Sections/PlatformsPage.vue";
import ProductsPage from "./Sections/ProductsPage.vue";
import ProductReview from "./Sections/ProductReview.vue";
import FrequencyPage from "./Sections/FrequencyPage.vue";
import CatAndSearchTerms from "./Sections/CatAndSearchTerms.vue";
import CategoryPage from "./Sections/CategoryPage.vue";
import Pincodes from "./Sections/Pincodes.vue";
import Loader from "../../Components/Loader.vue";
export default {
	name: "DemoForm",
	components: {
		Loader,
		FeaturesPage,
		PlatformsPage,
		ProductsPage,
		ProductReview,
		FrequencyPage,
		CatAndSearchTerms,
		CategoryPage,
		Pincodes,
	},
	data() {
		return {
			componentMapper: {
				Features: FeaturesPage,
				Platforms: PlatformsPage,
				"Add Products": ProductsPage,
				"Product Review": ProductReview,
				Frequency: FrequencyPage,
				"Category": CategoryPage,
				"Search Terms": CatAndSearchTerms,
				Pincodes: Pincodes,
			},
			couponCodeEnterPopup: !JSON.parse(localStorage.coupon_applied),
			congratulationsPopup: false,
			storeCouponCodeValue: null,
			verifyCouponCodeLoader: false,
			storeCongratulationsPopupDetails: null
		};
	},
	computed: {
		...mapState("DemoStore", ["loader", "totalFeatures", "sections", "selectedSection"]),
		filteredSections() {
			const region = this.$store.state.DemoStore.selectedRegion.name;
			if (region === 'United Arab Emirates') {
				return this.sections.filter(section => section !== 'Pincodes');
			}
			return this.sections;
		}
	},
	mounted() {
		// console.log(JSON.parse(localStorage.reviewUserData).data.re, 'sss')
		this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
		this.$store.dispatch("DemoStore/setUpdatedStatus", '')
		const { region_id, region_name } = JSON.parse(localStorage.reviewUserData).data;
		this.$store.dispatch("DemoStore/setSelectedRegion", {
			id: region_id,
			name: region_name,
		});
		this.getFeatures();
		// console.log(this.$store.state.DemoStore.selectedRegion.name)
	},
	methods: {
		...mapActions("DemoStore", [
			"setDemoLoader",
			"setTotalFeatures",
			"setSelectedFeatures",
			"setSelectedSection",
		]),
		getFeatures() {
			this.setDemoLoader(true);
			this.setTotalFeatures(null);
			const url = `/api/demo/feature?region_id=${this.$store.state.DemoStore.selectedRegion.id}`;
			this.$http
				.get(url)
				.then((res) => {
					let features = res.body.data.data;
					let selectedFeats = features.filter((feat) => feat.isSelected && feat);
					this.setTotalFeatures(features);
					this.setSelectedFeatures(selectedFeats);
					this.setSelectedSection("Features");
					this.setDemoLoader(false);
				})
				.catch((err) => {
					console.log("error in getting features", err);
					this.setDemoLoader(false);
				});
		},
		setPageSelection(section) {
			this.setSelectedSection(section);
		},

		clickToCopyCouponCode() {
			navigator.clipboard.writeText(this.storeCouponCodeValue).then(() => {
				this.$bvToast.toast(`copied ! ✔️`, {
					title: "Coupon Code",
					autoHideDelay: 1000,
					variant: "success",
				});
			}).catch(err => {
				console.error("Failed to copy:", err);
			});
		},

		verifyCouponCodeFromApi() {
			let self = this;
			self.verifyCouponCodeLoader = true;
			const url = `/api/coupon/apply`;
			const payload = {
				coupon_code: this.storeCouponCodeValue
			}

			self.$http.post(url, payload).then(res => {
				self.storeCongratulationsPopupDetails = {
					...res.body.data,
					regionName: this.$store.state.DemoStore.selectedRegion.name || ''
				};
				this.$bvToast.toast(`Coupon code verified successfully.`, {
					title: "Weavr Sense",
					variant: "success",
					toaster: "b-toaster-top-right",
					autoHideDelay: 1000
				});
				self.verifyCouponCodeLoader = false;
				self.couponCodeEnterPopup = false;
				self.congratulationsPopup = true;
			}).catch(err => {
				self.verifyCouponCodeLoader = false;
				this.$bvToast.toast(`${err.body.data}`, {
					title: "Weavr Sense",
					variant: "danger",
					toaster: "b-toaster-top-right",
					autoHideDelay: 1000
				});
			})
		}
	},
};
</script>

<style scoped>
.stepper-section {
	color: var(--primary_brand);
	font-size: 16px;
	font-weight: 600;
	margin-block: 10px 20px;
}

.tabs {
	list-style: none;
}

.activeSectionText {
	color: var(--primary_brand) !important;
	padding-bottom: 11px;
	border-bottom: 0.07rem solid var(--primary_brand) !important;
}

.deactiveTextColor {
	color: #536387 !important;
	padding-bottom: 10px !important;
}

.cursor-pointer {
	cursor: pointer !important;
}

.card {
	border-radius: 0.7rem !important;
	border: none !important;
	margin-bottom: 1rem;
	padding: 16px 32px !important;
}

button.primarycolor {
	background: var(--primary_brand);
	font-family: Poppins, sans-serif;
	color: #fff;
	padding: 0.5rem;
	border-radius: 10px;
	border: none;
	letter-spacing: 0.2px;
	font-weight: 700;
	font-size: 16px;
	width: 100%;
}

button.primarycolor:hover,
.btn-secondary:not(:disabled):not(.disabled):active {
	color: white;
	background: var(--primary_brand-80);
}

.inputIconContainer {
	top: 50%;
	transform: translateY(-50%);
	padding: 10px;
}

.inputFieldCouponContainer input {
	padding: 0.6rem;
	border: 0.08rem solid #aeaeae;
	width: 100%;
	height: 100%;
	background: #fff !important;
	outline: none !important;
	border-radius: 7px;
	box-shadow: none !important;
	padding-left: 35px !important;
}

.crossModalPopupCustom {
	color: #292929;
	text-shadow: none;
	position: absolute;
	top: -10px;
	right: -14px;
	font-size: 16px;
	background: var(--primary_brand-10);
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 15px;
}

.bgCouponImgContainer {
	background: url("/Icons_SVG/bgCouponImg.svg") no-repeat right center;
	background-position: top;
	background-size: contain;
}

.btn.disabled {
	cursor: not-allowed !important;
}

.couponCodeEnterPopupClass {
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	position: fixed;
	top: 40%;
	left: 50%;
	transform: translate(-50%, -40%);
	padding: 35px 45px;
	border-radius: 14px;
	background: #fff;
}
</style>
<style>
.modal-open .modal {
	overflow-y: hidden !important;
}

.modal {
	padding: 0 !important;
}

.containerOverflowClass {
	width: 100%;
	overflow-x: visible !important;
}
</style>
